import { Button, Center, Divider, Group, Stack, Title } from '@mantine/core';
import {
  IconArrowRight,
  IconDatabaseEdit,
  IconDatabasePlus,
  IconFileDollar,
  IconUserDollar,
} from '@tabler/icons-react';
import { i18nKeys, tKeysLoose, useTranslation } from 'locales';

import { useAutomationWizardController } from '../controller';

import { ModelButton } from './ModelButton';

export const Step2 = () => {
  const { t } = useTranslation();
  const {
    automation,
    form: { setFieldValue },
    settings: { handleSetTrigger },
    navigation: { goToNextStep, isStep2Valid, isEditMode },
  } = useAutomationWizardController();

  return (
    <Center>
      <Stack>
        <Group align="start">
          <Stack gap="sm">
            <Title order={5} mb="md">
              {t(i18nKeys.AUTOMATION.WIZARD.STEP2.SELECT_MODEL)}
            </Title>
            <ModelButton
              icon={<IconFileDollar size={34} stroke={1} />}
              name={t(i18nKeys.AUTOMATION.WIZARD.STEP2.INVOICE_NAME)}
              description={t(i18nKeys.AUTOMATION.WIZARD.STEP2.INVOICE_DESCRIPTION)}
              isActive={automation.targetModel === 'invoice'}
              isDisabled={isEditMode}
              onClick={() => setFieldValue('targetModel', 'invoice')}
            />
            <ModelButton
              icon={<IconUserDollar size={34} stroke={1} />}
              name={t(i18nKeys.AUTOMATION.WIZARD.STEP2.CUSTOMER_NAME)}
              description={t(i18nKeys.AUTOMATION.WIZARD.STEP2.CUSTOMER_DESCRIPTION)}
              isActive={automation.targetModel === 'debtor'}
              isDisabled={isEditMode}
              onClick={() => setFieldValue('targetModel', 'debtor')}
            />
          </Stack>
          <Divider orientation="vertical" />
          <Stack gap="sm">
            <Title order={5} mb="md">
              {t(i18nKeys.AUTOMATION.WIZARD.STEP2.SELECT_TRIGGERS)}
            </Title>
            <ModelButton
              withCheckmark
              icon={<IconDatabasePlus size={34} stroke={1} />}
              name={t(i18nKeys.AUTOMATION.WIZARD.STEP2.ONCREATE)}
              description={t(
                tKeysLoose.AUTOMATION.WIZARD.STEP2.ON_CREATE_DESCRIPTION[
                  automation.targetModel.toUpperCase() as any
                ],
              )}
              isActive={automation.triggers.includes('on_create')}
              onClick={() => handleSetTrigger('on_create')}
            />
            <ModelButton
              withCheckmark
              icon={<IconDatabaseEdit size={34} stroke={1} />}
              name={t(i18nKeys.AUTOMATION.WIZARD.STEP2.ONUPDATE)}
              description={t(
                tKeysLoose.AUTOMATION.WIZARD.STEP2.ON_UPDATE_DESCRIPTION[
                  automation.targetModel.toUpperCase() as any
                ],
              )}
              isActive={automation.triggers.includes('on_update')}
              onClick={() => handleSetTrigger('on_update')}
            />
          </Stack>
        </Group>
        <Button
          w="100%"
          mt="lg"
          disabled={!isStep2Valid()}
          rightSection={<IconArrowRight stroke={1.5} size={20} />}
          onClick={goToNextStep}
        >
          {t(i18nKeys.AUTOMATION.WIZARD.STEP2.NEXT)}
        </Button>
      </Stack>
    </Center>
  );
};
